import { MissingQueryParameterError } from "@mittwald/flow-lib/dist/errors/MissingQueryParameterError";
import is from "@sindresorhus/is";
import type { ZodSchema } from "zod";
import DecodeUrlParameterError from "./DecodeUrlParameterError";

export class EncodedCheckoutState<T> {
  public readonly schema: ZodSchema<T>;

  public constructor(schema: ZodSchema<T>) {
    this.schema = schema;
  }

  public decodeFromParam(paramName: string): T {
    const valueFromParam = new URL(window.location.toString()).searchParams.get(
      paramName,
    );

    if (valueFromParam === null) {
      throw new MissingQueryParameterError(paramName);
    }

    try {
      return this.decode(valueFromParam);
    } catch (error) {
      if (is.error(error)) {
        throw new DecodeUrlParameterError(error.message);
      }
      throw error;
    }
  }

  public decode(value: string): T {
    return this.schema.parse(JSON.parse(atob(value)));
  }

  public encode(data: T): string {
    return btoa(JSON.stringify(data));
  }
}

export default EncodedCheckoutState;
